<template>
  <table class="table table-light table-striped table-hover" id="tbl-assembly-items">
    <thead class="table-head">
    <tr>
      <th>
        <div class="form-check">
          <input class="form-check-input" type="checkbox" 
                 :checked="isAllSelected" 
                 :indeterminate="isIndeterminate"
                 @change="toggleSelectAll"
                 id="select-all-checkbox">
          <label class="form-check-label" for="select-all-checkbox">
            Zvol
          </label>
        </div>
      </th>
      <th>Název dílce</th>
      <th>Materiál</th>
      <th style="text-align: end;">Plocha</th>
      <th style="text-align: end;">Váha</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, key) in calculationItems" :key="key">
      <td>
        <div class="form-check">
          <input class="form-check-input" :checked="resolveSelection(item)" type="checkbox" :value="item.id" @change="setSelected"
                 :id="caption + '-item-' + item.id"
                 :name="caption + '-item-' + item.id">
        </div>
      </td>
      <td> {{ item.name }}</td>
      <td> {{ item.itemOrigin.price_list_item.name }}</td>
      <td style="text-align: end;"> {{ item.area }} m<sup>2</sup></td>
      <td style="text-align: end;"> {{ item.weight }} kg</td>
    </tr>
    </tbody>
  </table>
</template>

<script setup>
import {ref, defineProps, defineEmits, computed, watch, onMounted, nextTick} from 'vue'

const props = defineProps(['calculationItems', 'selectedItems', 'caption', 'totalWeight', 'maxWeight'])
const emit = defineEmits(['update:selectedItems', 'update:maxWeight', 'update:totalWeight'])

const selectedItemInternal = ref(props.selectedItems === undefined || props.selectedItems === null ? [] : props.selectedItems)

const resolveSelection = (item) => {
  return selectedItemInternal.value.includes(item.id)
}

// Computed properties pro stav hlavního checkbox
const isAllSelected = computed(() => {
  return props.calculationItems.length > 0 &&
         selectedItemInternal.value.length === props.calculationItems.length
})

const isIndeterminate = computed(() => {
  return selectedItemInternal.value.length > 0 &&
         selectedItemInternal.value.length < props.calculationItems.length
})

// Toggle funkce s indeterminate stavem
const toggleSelectAll = () => {
  if (isAllSelected.value) {
    // Pokud je vše vybráno, zruš výběr
    selectedItemInternal.value = []
  } else {
    // Jinak vyber vše
    selectedItemInternal.value = props.calculationItems.map(item => item.id)
  }
  emit('update:selectedItems', selectedItemInternal.value)
}

// Nastavení indeterminate stavu pro checkbox
watch([isIndeterminate], () => {
  nextTick(() => {
    const checkbox = document.getElementById('select-all-checkbox')
    if (checkbox) {
      checkbox.indeterminate = isIndeterminate.value
    }
  })
})

const setSelected = (event) => {
  const value = parseInt(event.target.value)
  const index = selectedItemInternal.value.indexOf(value)
  if (event.target.checked) {
    if (index < 0) {
      selectedItemInternal.value.push(value)
    }
  } else {
    if (index > -1) {
      selectedItemInternal.value.splice(index, 1)
    }
  }
  emit('update:selectedItems', selectedItemInternal.value)
}

// Zbytek kódu zůstává stejný...
const totalWeight = computed(() => {
  if (selectedItemInternal.value.length > 0) {
    const totalWeight = props.calculationItems
        .filter(obj => selectedItemInternal.value.includes(obj.id))
        .reduce((sum, obj) => sum + obj.weight, 0)
    return totalWeight;
  } else {
    return 0
  }
})

const maxWeight = computed(() => {
  if (selectedItemInternal.value.length > 0) {
    const maxWeight = Math.max(...props.calculationItems
        .filter(obj => selectedItemInternal.value.includes(obj.id))
        .map(obj => obj.weight))
    return maxWeight;
  } else {
    return 0
  }
})

watch(maxWeight, (newValue) => {
  emit('update:maxWeight', newValue)
})

watch(totalWeight, (newValue) => {
  emit('update:totalWeight', newValue)
})

onMounted(() => {
  emit('update:totalWeight', totalWeight.value)
  emit('update:maxWeight', maxWeight.value)
})

</script>

<style scoped>
</style>